module.exports = __webpack_public_path__ + "8cc6532eb5ce3812b57e8f13b851bbcc.jpg";